import { Skeleton } from '@/components/ui';

export default function PoliciesAccordionSkeleton(): React.ReactNode {
  return (
    <div className='mt-10'>
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton
          key={index}
          className='mt-3 flex h-12 w-full items-center justify-between rounded-md bg-gray-100 px-4'
        >
          <Skeleton className='h-6 w-[10rem] rounded-md bg-gray-300' />
          <Skeleton className='h-6 w-6 rounded-md bg-gray-300' />
        </Skeleton>
      ))}
    </div>
  );
}
